import Hunt from 'huntjs';
import { Breakpoints } from '../utils/breakpoints';

export const SetupInViewDetection = () => {
  const els = document.querySelectorAll('.-detect-in-viewport');

  const bp = new Breakpoints();
  let offset = -1 * window.innerHeight / 100;
  offset *= bp.breakpointDown('xl') ? 5 : 0;

  new Hunt(els, {
    offset,
    enter: (el) => {
      el.classList.add('-in-viewport'); 
      if (el.firstElementChild) {
        if (el.firstElementChild.classList.contains('animate__animated')) {
          el.firstElementChild.classList.add('-start-animation');
        }
      }
      if (el.classList.contains('block__card')) {
        if (el.firstElementChild.classList.contains('has-background-color--transparent') && el.firstElementChild.children) {
          if (el.firstElementChild.children[0].classList.contains('animate__animated')) {
            el.firstElementChild.children[0].classList.add('-start-animation');
            el.firstElementChild.children[1].classList.add('-start-animation');
          }
        }
      }      
    },
    leave: (el) => {
      el.classList.remove('-in-viewport');
    }
  });
};